// @ts-nocheck
import React from 'react';
import PropTypes from 'react-proptypes';
import { RepeatableValue } from '@fulcrumapp/fulcrum-core';
import cx from 'classnames';
import { RepeatableIcon } from '../../icons';

export default class RepeatableElementTitle extends React.Component {
  static propTypes = {
    // className: PropTypes.string,
    onClick: PropTypes.func,
    value: PropTypes.instanceOf(RepeatableValue).isRequired,
  };

  render() {
    const { styles } = RepeatableElementTitle;

    return (
      <div
        className={css(styles.section)}
        onClick={this.props.onClick}
      >
        <div className={css(styles.icon)}><RepeatableIcon /></div>
        <div className={css(styles.title)}>
          <span title={this.props.value.element.label} className={css(styles.label)}>{this.props.value.element.label}</span>
        </div>
        <div className={css(styles.arrowContainer)}>
          <div className={css(styles.angle)} />
          <div className={css(styles.angleWhite)} />
        </div>
        <div className={css(styles.accessoryContainer)}>
          {this.renderAccessory()}
        </div>
      </div>
    );
  }

  renderAccessory() {
    const { styles } = RepeatableElementTitle;

    const classes = css(styles.accessory, this.props.value.isEmpty ? styles.noItems : styles.someItems);

    return <span className={classes}>{this.props.value.displayValue}</span>;
  }
}

const styles = cssInJS({
  section: {
    display: 'flex',
    flexDirection: 'row',
    height: 38,
    cursor: 'pointer',
    fontWeight: 'bold',
    // borderTop: THEME.fieldBorderLight,
    borderBottom: THEME.fieldBorderMedium,

    ':hover': {
    },
  },

  icon: {
    width: 37,
    padding: 8,
    paddingBottom: 0,
  },

  title: {
    flexGrow: 1,
  },

  label: {
    display: 'inline-block',
    paddingTop: 10,
    paddingLeft: 12,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    maxWidth: 500,
  },

  arrowContainer: {
    width: 13,
    position: 'relative',
    overflow: 'hidden',
    left: 1,
    zIndex: 1,
  },

  angle: {
    position: 'absolute',
    display: 'inline-block',
    left: 1,
    top: -2,
    height: 40,
    width: 0,
    borderStyle: 'solid',
    borderWidth: '20px 0 20px 10px',
    borderColor: 'transparent transparent transparent #e2e2e2',
    backgroundColor: '#f1f1f1',
  },

  angleWhite: {
    position: 'absolute',
    display: 'inline-block',
    left: 0,
    width: 0,
    top: -2,
    height: 40,
    borderStyle: 'solid',
    borderWidth: '20px 0 20px 10px',
    borderColor: 'transparent transparent transparent #fff',
  },

  accessoryContainer: {
    backgroundColor: '#f1f1f1',
    textAlign: 'center',
    verticalAlign: 'middle',
    width: 123,
    position: 'relative',
    left: -1,
  },

  accessory: {
    marginTop: 10,
    padding: '2px 8px',
    fontSize: 11,
    fontWeight: 'bold',
    borderRadius: 8,
    color: '#fff',
    display: 'inline-block',
    verticalAlign: 'middle',
  },

  noItems: {
    backgroundColor: '#c3c3c3',
  },

  someItems: {
    backgroundColor: THEME.linkColor,
  },
});

RepeatableElementTitle.styles = styles;
